module.exports = __webpack_public_path__ + "img/Belize.5f410821.svg";